const { mergeMap } = require('rxjs/operators')
const { ofType } = require('redux-observable')

const { setting: settingApi } = require('@doctoroncallcom/api')
const {
  GET_CAMPAIGN_LIST,
  CREATE_CAMPAIGN,
  UPDATE_CAMPAIGN,
  DELETE_CAMPAIGN,
  GET_ROUTE_LIST,
  CREATE_ROUTE,
  UPDATE_ROUTE,
  DELETE_ROUTE,
  DO_TEST_AUDIO_CALL,
  GET_PRIORITY_TEAM_LIST,
  GET_PRIORITY_TEAM_DETAIL,
  CREATE_PRIORITY_TEAM,
  UPDATE_PRIORITY_TEAM,
  ADD_DOCTOR_TO_PRIORITY_TEAM,
  DELETE_PRIORITY_TEAM,
  GET_WEBHOOK_LIST,
  GET_WEBHOOK,
  CREATE_WEBHOOK,
  DELETE_WEBHOOK
} = require('./constants')

const {
  getCampaignListSuccess,
  getCampaignListError,
  createCampaignSuccess,
  createCampaignError,
  updateCampaignSuccess,
  updateCampaignError,
  deleteCampaignSuccess,
  deleteCampaignError,
  getRouteListSuccess,
  getRouteListError,
  createRouteSuccess,
  createRouteError,
  updateRouteSuccess,
  updateRouteError,
  deleteRouteSuccess,
  deleteRouteError,
  doTestAudioCallSuccess,
  doTestAudioCallError,
  getPriorityTeamListSuccess,
  getPriorityTeamListError,
  getWebhookListSuccess,
  getWebhookListError,
  getWebhookSuccess,
  getWebhookError,
  createWebhookSuccess,
  createWebhookError,
  deleteWebhookSuccess,
  deleteWebhookError,
  getPriorityTeamDetailSuccess,
  getPriorityTeamDetailError,
  createPriorityTeamSuccess,
  createPriorityTeamError,
  updatePriorityTeamSuccess,
  updatePriorityTeamError,
  addDoctorToPriorityTeamSuccess,
  addDoctorToPriorityTeamError,
  deletePriorityTeamSuccess,
  deletePriorityTeamError,
} = require('./actions')

const getCampaignList = (action$, state$, { api }) => action$.pipe(
  ofType(GET_CAMPAIGN_LIST),
  mergeMap(action => settingApi.getCampaignListApi(api, {
    search: action.payload.search,
  })
    .then(response => getCampaignListSuccess(response.data))
    .catch(error => getCampaignListError(error))),
)

const createCampaign = (action$, state$, { api }) => action$.pipe(
  ofType(CREATE_CAMPAIGN),
  mergeMap(action => settingApi.createCampaignApi(api, action.payload.campaignData)
    .then(response => createCampaignSuccess(response.data))
    .catch(error => createCampaignError(error))),
)

const updateCampaign = (action$, state$, { api }) => action$.pipe(
  ofType(UPDATE_CAMPAIGN),
  mergeMap(action => settingApi.updateCampaignApi(api,
    action.payload.id, action.payload.campaignData)
    .then(response => updateCampaignSuccess(response.data))
    .catch(error => updateCampaignError(error))),
)

const deleteCampaign = (action$, state$, { api }) => action$.pipe(
  ofType(DELETE_CAMPAIGN),
  mergeMap(action => settingApi.deleteCampaignApi(api, action.payload.id)
    .then(response => deleteCampaignSuccess(response.data))
    .catch(error => deleteCampaignError(error))),
)

const getRouteList = (action$, state$, { api }) => action$.pipe(
  ofType(GET_ROUTE_LIST),
  mergeMap(() => settingApi.getRouteListApi(api, { })
    .then(response => getRouteListSuccess(response.data))
    .catch(error => getRouteListError(error))),
)

const createRoute = (action$, state$, { api }) => action$.pipe(
  ofType(CREATE_ROUTE),
  mergeMap(action => settingApi.createRouteApi(api, action.payload.routeData)
    .then(response => createRouteSuccess(response.data))
    .catch(error => createRouteError(error))),
)

const updateRoute = (action$, state$, { api }) => action$.pipe(
  ofType(UPDATE_ROUTE),
  mergeMap(action => settingApi.updateRouteApi(api,
    action.payload.id, action.payload.routeData)
    .then(response => updateRouteSuccess(response.data))
    .catch(error => updateRouteError(error))),
)

const deleteRoute = (action$, state$, { api }) => action$.pipe(
  ofType(DELETE_ROUTE),
  mergeMap(action => settingApi.deleteRouteApi(api, action.payload.id)
    .then(response => deleteRouteSuccess(response.data))
    .catch(error => deleteRouteError(error))),
)

const doTestAudioCall = (action$, state$, { api }) => action$.pipe(
  ofType(DO_TEST_AUDIO_CALL),
  mergeMap(action => settingApi.doTestAudioCallApi(api, action.payload.callData)
    .then(response => doTestAudioCallSuccess(response.data))
    .catch(error => doTestAudioCallError(error))),
)

const geWebhookList = (action$, state$, { api }) => action$.pipe(
  ofType(GET_WEBHOOK_LIST),
  mergeMap(action => settingApi.getWebhookListApi(api, {
    search: action.payload.search,
  })
    .then(response => getWebhookListSuccess(response.data))
    .catch(error => getWebhookListError(error))),
)

const getWebhook = (action$, state$, { api }) => action$.pipe(
  ofType(GET_WEBHOOK),
  mergeMap(action => settingApi.getWebhookApi(api, action.payload.topic)
    .then(response => getWebhookSuccess(response.data))
    .catch(error => getWebhookError(error))),
)

const createWebhook = (action$, state$, { api }) => action$.pipe(
  ofType(CREATE_WEBHOOK),
  mergeMap(action => settingApi.createWebhookApi(api, action.payload.webhookData)
    .then(response => createWebhookSuccess(response.data))
    .catch(error => createWebhookError(error))),
)

const deleteWebhook = (action$, state$, { api }) => action$.pipe(
  ofType(DELETE_WEBHOOK),
  mergeMap(action => settingApi.deleteWebhookApi(api, action.payload.webhookData)
    .then(response => deleteWebhookSuccess(response.data))
    .catch(error => deleteWebhookError(error))),
)

const getPriorityTeamList = (action$, state$, { api }) => action$.pipe(
  ofType(GET_PRIORITY_TEAM_LIST),
  mergeMap(action => settingApi.getPriorityTeamListApi(api, {
    search: action.payload.search,
  })
    .then(response => getPriorityTeamListSuccess(response.data))
    .catch(error => getPriorityTeamListError(error))),
)

const getPriorityTeamDetail = (action$, state$, { api }) => action$.pipe(
  ofType(GET_PRIORITY_TEAM_DETAIL),
  mergeMap(action => settingApi.getPriorityTeamDetailApi(api, action.payload.id)
    .then(response => getPriorityTeamDetailSuccess(response.data))
    .catch(error => getPriorityTeamDetailError(error))),
)

const createPriorityTeam = (action$, state$, { api }) => action$.pipe(
  ofType(CREATE_PRIORITY_TEAM),
  mergeMap(action => settingApi.createPriorityTeamApi(api, action.payload.teamData)
    .then(response => createPriorityTeamSuccess(response.data))
    .catch(error => createPriorityTeamError(error))),
)

const updatePriorityTeam = (action$, state$, { api }) => action$.pipe(
  ofType(UPDATE_PRIORITY_TEAM),
  // eslint-disable-next-line max-len
  mergeMap(action => settingApi.updatePriorityTeamApi(api, action.payload.id, action.payload.teamData)
    .then(response => updatePriorityTeamSuccess(response.data))
    .catch(error => updatePriorityTeamError(error))),
)

const addDoctorToPriorityTeam = (action$, state$, { api }) => action$.pipe(
  ofType(ADD_DOCTOR_TO_PRIORITY_TEAM),
  // eslint-disable-next-line max-len
  mergeMap(action => settingApi.addDoctorToPriorityTeamApi(api, action.payload.id, action.payload.doctorsData)
    .then(response => addDoctorToPriorityTeamSuccess(response.data))
    .catch(error => addDoctorToPriorityTeamError(error))),
)

const deletePriorityTeam = (action$, state$, { api }) => action$.pipe(
  ofType(DELETE_PRIORITY_TEAM),
  mergeMap(action => settingApi.deletePriorityTeamApi(api, action.payload.id)
    .then(response => deletePriorityTeamSuccess(response.data))
    .catch(error => deletePriorityTeamError(error))),
)

module.exports = {
  getCampaignList,
  createCampaign,
  updateCampaign,
  deleteCampaign,
  getRouteList,
  createRoute,
  updateRoute,
  deleteRoute,
  doTestAudioCall,
  getPriorityTeamList,
  geWebhookList,
  getWebhook,
  createWebhook,
  deleteWebhook,
  getPriorityTeamDetail,
  createPriorityTeam,
  updatePriorityTeam,
  addDoctorToPriorityTeam,
  deletePriorityTeam,
}